import { Component } from '@grafikr/components';
import { debounceTime, fromEvent } from 'rxjs';

import { NonNullish } from 'utils/nullish-check';

export default Component((node) => {
  const ACTIVE_CLASS = 'announcement-bar--active';
  const CURRENT_ITEM_CLASS = 'announcement-bar__item--current';
  const PREVIOUS_ITEM_CLASS = 'announcement-bar__item--previous';
  const NEXT_ITEM_CLASS = 'announcement-bar__item--next';

  const closeTrigger = NonNullish(node.querySelector('[data-close]'));
  const items = Array.from(node.querySelectorAll('[data-item]'));
  const interval = parseInt(NonNullish(node.getAttribute('data-interval')), 10);

  const updateVisibleHeight = () => {
    const rect = node.getBoundingClientRect();
    const visibleHeight = Math.max(rect.height + Math.min(rect.top, 0), 0);

    document.documentElement.style.setProperty(
      '--announcement-bar-visible-height',
      `${visibleHeight}px`,
    );
  };

  const close = () => {
    node.hidden = true;
    document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    document.documentElement.style.setProperty('--announcement-bar-visible-height', '0px');
    sessionStorage.setItem('hideAnnouncementBar', 'true');
  };

  const initItemInterval = () => {
    if (items.length <= 1) {
      return;
    }

    setInterval(() => {
      const currentItem =
        items.find((item) => item.classList.contains(CURRENT_ITEM_CLASS)) ?? NonNullish(items[0]);
      const currentIndex = items.indexOf(currentItem);
      const nextItem = items[currentIndex + 1] ?? NonNullish(items[0]);

      items.forEach((item) => {
        if (item === currentItem) {
          item.classList.remove(CURRENT_ITEM_CLASS);
          item.classList.add(PREVIOUS_ITEM_CLASS);

          setTimeout(() => {
            item.classList.remove(PREVIOUS_ITEM_CLASS);
            item.classList.add(NEXT_ITEM_CLASS);
          }, 300);
        } else if (item === nextItem) {
          item.classList.remove(NEXT_ITEM_CLASS);
          item.classList.add(CURRENT_ITEM_CLASS);
        }
      });
    }, interval);
  };

  const handleHeaderModals = () => {
    document.addEventListener('header-modal:open', () => {
      node.classList.add(ACTIVE_CLASS);
    });

    document.addEventListener('header-modal:close', () => {
      node.classList.remove(ACTIVE_CLASS);
    });
  };

  fromEvent(window, 'scroll').pipe(debounceTime(10)).subscribe(updateVisibleHeight);
  closeTrigger.addEventListener('click', close);
  initItemInterval();
  handleHeaderModals();
});
